import React from 'react';
import { GridRowProps } from '@progress/kendo-react-grid';
import { Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import styles from './_external-link.module.scss';
import { DealerReport } from '../../../Models/DealerReport';
export const ExternalLinkCell = (props: GridRowProps) => {
  return (
    <td className={styles.externalLinkCell}>
      <Link
        to={props.dataItem!.externalLink}
        target='_blank'
        component={RouterLink}
        onClick={(event: React.SyntheticEvent) => event.stopPropagation()}
      >
        <OpenInNewIcon color="primary" />
      </Link>
    </td>
  );
};

export const ExternalReportInputLinkCell = (props: GridRowProps) => {
  const dealerReport: DealerReport = props.dataItem;
  return (
    <td className={styles.externalLinkCell}>
      <Link
        to={`/performanceReporting/${dealerReport.id}`}
        target='_blank'
        component={RouterLink}
        onClick={(event: React.SyntheticEvent) => event.stopPropagation()}
      >
        <span style={{color: '#d95137', fontSize: '25px', cursor: 'pointer'}} className="k-icon k-font-icon k-i-track-changes" />
      </Link>
    </td>
  );
};
export const InternalReportLinkCell = (props: GridRowProps & {hideCellContents?: boolean; onReportClick: (dealerReport: DealerReport) => void; icon: React.ReactNode}) => {
  if(props.hideCellContents === true) {
    return <td></td>
  }
  return (
    <td className={styles.reportIconCell} 
      style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}
    >
      <div style={{height: '100%'}}       
        onClick={(event: React.SyntheticEvent) => 
        {
          event.stopPropagation();
          props.onReportClick(props.dataItem);
        }}
      >
        {props.icon}
      </div>
    </td>
  );
};